// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"57":"db554bc0","111":"f70eb0cf","498":"48ce3a66","702":"81122b11","740":"797b43c0"}[chunkId] + ".chunk.js";
};